var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "250pt",
    height: "250pt",
    viewBox: "0 0 250 250",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,250) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1105 2489 c-530 -71 -950 -450 -1070 -964 -52 -224 -39 -454 39 -682 132 -388 463 -694 861 -798 213 -55 413 -55 630 0 414 105 761 439 879 847 30 103 56 271 56 358 0 87 -26 255 -56 358 -88 303 -315 584 -594 736 -215 117 -518 176 -745 145z m184 -555 c107 -54 231 -211 231 -293 0 -111 -134 -86 -270 48 -97 96 -140 195 -110 252 16 28 84 25 149 -7z m720 -336 c94 -71 131 -109 131 -134 0 -37 -30 -47 -74 -23 l-36 19 7 -27 c15 -54 8 -274 -11 -346 -44 -169 -109 -281 -230 -403 -135 -135 -280 -212 -460 -243 -172 -31 -421 7 -475 73 -16 19 -11 56 11 69 12 8 36 5 90 -12 50 -16 109 -25 189 -28 150 -7 238 11 378 79 90 43 115 61 190 136 160 161 231 332 231 552 l-1 95 -20 -27 c-24 -33 -54 -36 -69 -8 -8 16 -5 45 14 126 40 165 46 169 135 102z m-1318 -255 c108 -53 239 -216 239 -297 0 -106 -144 -81 -273 48 -176 176 -154 341 34 249z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYUsd);
export default __webpack_public_path__ + "static/media/yUSD.c2dc09abb494e98e7a5d4f74cc13bec5.svg";
export { ForwardRef as ReactComponent };